import { render, staticRenderFns } from "./assessment-components.vue?vue&type=template&id=17ea4563&scoped=true&"
import script from "./assessment-components.vue?vue&type=script&lang=js&"
export * from "./assessment-components.vue?vue&type=script&lang=js&"
import style0 from "./assessment-components.vue?vue&type=style&index=0&id=17ea4563&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ea4563",
  null
  
)

export default component.exports